import { EVENT_TYPES } from './event-types'

export default {
  IDENTIFY: {
    EVENT_TYPE: EVENT_TYPES.IDENTIFY,
    EVENT_NAME: 'identify',
    EVENT_DATA_PARAMS: ['user_id'],
  },
  LOGIN_PHONE_NUMBER_INPUT_INTERACTED: {
    EVENT_NAME: 'login__phone_number_input_interacted',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_PAGE_INPUT_PHONE_NUMBER_PAGE_VIEWED: {
    EVENT_NAME: 'login__phone_number_log_in_viewed',
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_PAGE_OTP_INPUT_PAGE_VIEWED: {
    EVENT_NAME: 'login__confirm_otp_log_in_viewed',
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_PHONE_NUMBER_UPDATED: {
    EVENT_NAME: 'login__phone_number_updated',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_PHONE_NUMBER_REMOVED: {
    EVENT_NAME: 'login__phone_number_removed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_CHANGE_PHONE_NUMBER_CLICKED: {
    EVENT_NAME: 'login__single_checkout_change_phone_number_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_PAGE_OTP_INPUT_INTERACTED: {
    EVENT_NAME: 'login__otp_input_interacted',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_OTP_SEND_OTP_BUTTON_CLICKED: {
    EVENT_NAME: 'login__otp_send_otp_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_OTP_RESEND_OTP_BUTTON_CLICKED: {
    EVENT_NAME: 'login__resend_otp_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_SHOW_TERMS_AND_CONDITIONS_LINK_CLICKED: {
    EVENT_NAME: 'login__terms_and_condition_popup_show_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_TERMS_AND_CONDITIONS_CHECKED: {
    EVENT_NAME: 'login__terms_and_condition_accepted_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_TERMS_AND_CONDITIONS_UNCHECKED: {
    EVENT_NAME: 'login__terms_and_condition_not_accepted_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_HIDE_TERMS_AND_CONDITIONS_LINK_CLICKED: {
    EVENT_NAME: 'login__terms_and_condition_popup_hide_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_SHOW_SHARIA_COMPLIANCE_LINK_CLICKED: {
    EVENT_NAME: 'login__sharia_popup_viewed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_HIDE_SHARIA_COMPLIANCE_LINK_CLICKED: {
    EVENT_NAME: 'login__sharia_popup_hide_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_LOGIN_BUTTON_CLICKED: {
    EVENT_NAME: 'login__confirm_account_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_DATA_PARAMS: ['mobile_number'],
  },
  LOGIN_CONFIRM_OTP_INITIATED: {
    EVENT_NAME: 'login__otp_confirmed_initiated_viewed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_SWITCH_LANGUAGE_TO_EN_CLICKED: {
    EVENT_NAME: 'login__lang_switched_to_en_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_SWITCH_LANGUAGE_TO_AR_CLICKED: {
    EVENT_NAME: 'login__lang_switched_to_ar_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_CONFIRM_OTP_FAILED: {
    EVENT_NAME: 'login__otp_confirmed_failed_viewed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_CONFIRM_OTP_SUCCESS: {
    EVENT_NAME: 'login__otp_confirmed_successful_viewed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_PAGE_VIEWED: {
    EVENT_NAME: 'account_recovery__page_viewed',
    EVENT_TYPE: EVENT_TYPES.PAGE,
  },
  ACCOUNT_RECOVERY_CONTINUE_CURRENT_ACCOUNT_CLICKED: {
    EVENT_NAME: 'account_recovery__continue_current_account_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_CREATE_NEW_ACCOUNT_CLICKED: {
    EVENT_NAME: 'account_recovery__create_new_account_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_ID_VERIFICATION_INITIATED: {
    EVENT_NAME: 'account_recovery__id_verification_initiated',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_ID_VERIFICATION_SUCCESS: {
    EVENT_NAME: 'account_recovery__id_verification_success',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_ID_VERIFICATION_FAILED: {
    EVENT_NAME: 'account_recovery__id_verification_failed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  ACCOUNT_RECOVERY_NEW_ACCOUNT_CREATED: {
    EVENT_NAME: 'account_recovery__new_account_created',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_STANDALONE_SUBMIT_PHONE: {
    EVENT_NAME: 'login__standalone_confirm_phone_number_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_BUTTON_ENABLED: {
    EVENT_NAME: 'login__login_button_enabled',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_SEND_OTP_REQUEST_SENT: {
    EVENT_NAME: 'login__send_otp_api_called',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_SEND_OTP_RESPONSE_RECEIVED: {
    EVENT_NAME: 'login__send_otp_api_response_received',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_NC_VERIFY_NUMBER_POPUP_VIEWED: {
    EVENT_NAME: 'login__newcustomer_verify_number_popup_viewed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_NC_VERIFY_NUMBER_POPUP_YES_CLICKED: {
    EVENT_NAME: 'login__newcustomer_verify_number_popup_yes_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_NC_VERIFY_NUMBER_POPUP_NO_CLICKED: {
    EVENT_NAME: 'login__newcustomer_verify_number_popup_no_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_PAGE_RENDERED: {
    EVENT_NAME: 'login__login_page_rendered',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IVR_PAGE_VIEWED: {
    EVENT_NAME: 'login__ivr_page_viewed',
    EVENT_TYPE: EVENT_TYPES.PAGE,
  },
  LOGIN_IVR_CALL_CUSTOMER_TRIGGERED: {
    EVENT_NAME: 'login__ivr_call_customer_triggered',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IVR_CALL_CUSTOMER_ACCEPTED: {
    EVENT_NAME: 'login__ivr_call_customer_accepted',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IVR_CALL_CUSTOMER_NOT_PICKED_UP: {
    EVENT_NAME: 'login__ivr_call_customer_not_picked_up',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IVR_CALL_CUSTOMER_TIMEOUT: {
    EVENT_NAME: 'login__ivr_call_customer_timeout',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IVR_CALL_CUSTOMER_RETRY_CLICKED: {
    EVENT_NAME: 'login__ivr_call_customer_retry_clicked',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  // In-App Approval tracking events
  LOGIN_IN_APP_APPROVAL_PAGE_VIEWED: {
    EVENT_NAME: 'login__external_trigger_screen',
    EVENT_TYPE: EVENT_TYPES.PAGE,
  },
  LOGIN_IN_APP_APPROVAL_CHANGE_NUMBER_CLICKED: {
    EVENT_NAME: 'login__use_different_number_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_CHANGE_METHOD_CLICKED: {
    EVENT_NAME: 'login__try_another_way_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_OPEN_APP_CLICKED: {
    EVENT_NAME: 'login__open_app_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_LANDING_PAGE_VIEWED: {
    EVENT_NAME: 'login__selfie_face_scan_intro_screen',
    EVENT_TYPE: EVENT_TYPES.PAGE,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_LANDING_PAGE_CONTINUE_CLICKED: {
    EVENT_NAME: 'login__selfie_face_scan_continue_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_LANDING_PAGE_RETRY_CLICKED: {
    EVENT_NAME: 'login__selfie_face_scan_retry_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_VERIFICATION_VERIFIED: {
    EVENT_NAME: 'login__payment_plan_verified_screen',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_VERIFICATION_FAILED: {
    EVENT_NAME: 'login__payment_plan_failed_screen',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_VERIFICATION_FAILED_DISMISSED: {
    EVENT_NAME: 'login__selfie_face_scan_verification_failed_dismissed',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_VERIFICATION_GOT_IT: {
    EVENT_NAME: 'login__web_purchase_rejected_got_it_click',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_FACE_SCAN_VERIFICATION_ERROR_SCREEN: {
    EVENT_NAME: 'login__web_purchase_rejected_screen',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
  LOGIN_IN_APP_APPROVAL_MAX_ATTEMPTS_EXCEEDED: {
    EVENT_NAME: 'login__selfie_face_scan_max_attempts_error_screen',
    EVENT_TYPE: EVENT_TYPES.TRACK,
  },
}
